import { Component } from '@angular/core';

@Component({
  selector: 'app-thanks-page',
  template: `
    <div class="container container--section container--article container--clearHeader">
    	<div class="grid">
    		<div class="grid__unit s-4-4 m-12-12 l-8-12 l-push-left-1-12">
    			<section class="richText">
    				<h1>{{ 'THANKS-PAGE.TITLE' | translate }}</h1>
    				<p>{{ 'THANKS-PAGE.INFO' | translate }}</p>
    			</section>
    		</div>
    	</div>
    </div>`
})
export class ThanksPageComponent {}
